export type CarrosselSource = string | string[];

export function isCarrosselFrames(
	carrossel: CarrosselSource | undefined | null
): carrossel is string[] {
	return Array.isArray(carrossel) && carrossel.length > 0;
}

export function hasCarrossel(
	carrossel: CarrosselSource | undefined | null
): boolean {
	if (!carrossel) return false;
	if (Array.isArray(carrossel)) return carrossel.length > 0;
	return carrossel.length > 0;
}

export function getCarrosselUrls(
	carrossel: CarrosselSource | undefined | null
): string[] {
	if (!carrossel) return [];
	return Array.isArray(carrossel) ? carrossel : [carrossel];
}

export function getCarrosselPreviewUrl(
	carrossel: CarrosselSource | undefined | null
): string {
	const urls = getCarrosselUrls(carrossel);
	return urls[0] || "";
}

export function getCarrosselTotalFrames(
	carrossel: CarrosselSource | undefined | null,
	spriteFrameCount = 36
): number {
	if (isCarrosselFrames(carrossel)) return carrossel.length;
	return spriteFrameCount;
}
